export const ADDRESS_VALIDATION_ERROR = {
  API_CHECKPOINT: 'validateAddress',
  API_ERROR_CODE: 'ADDRESS_VALIDATION_ERROR',
  CLIENT_ERROR_CODE: 'apiValidationError',
  FIELDS: ['city', 'postalCode', 'state'],
};

export const CPA_AUTH_DECLINED_ERROR = {
  API_ERROR_CODE: 'CC_AUTHORIZATION_DECLINED',
};

export const CROSS_BORDER_ERROR = {
  NON_DOMESTIC_CARD: 'NON_DOMESTIC_CARD',
};

export const SHARED_FI_ERROR = {
  EXCEEDING_TOTAL_DUPLICATE_LIMIT_SIGNUP:
    'EXCEEDING_TOTAL_DUPLICATE_LIMIT_SIGNUP',
  R_I_ERROR: 'R_I_ERROR',
};
